interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: (number | string)[] = [];
  for (let i = 1; i <= total; i += 1) {
    if (i === 1 || i === total || Math.abs(i - current) <= 1) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== "...") {
      pages.push("...");
    }
  }

  return (
    <nav aria-label="分页导航" className="flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-600 transition-colors enabled:hover:border-accent-400 enabled:hover:text-accent-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line text-lg" />
      </button>

      {pages.map((p, idx) =>
        typeof p === "number" ? (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`h-9 min-w-9 cursor-pointer rounded-md px-3 text-sm font-medium transition-colors ${
              p === current
                ? "bg-primary-500 text-white"
                : "border border-background-300 text-foreground-700 hover:border-accent-400 hover:text-accent-600"
            }`}
          >
            {p}
          </button>
        ) : (
          <span key={`dot-${idx}`} className="px-1 text-foreground-400">
            …
          </span>
        )
      )}

      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-600 transition-colors enabled:hover:border-accent-400 enabled:hover:text-accent-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </nav>
  );
}